import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';

/** @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor */

/**
 *
 * @returns {{ isFeatureEnabled: boolean, disabledMessage?: MessageDescriptor}}
 */
export const useOrderImportCustomStoreFeatureGate = () => usePlanFeatureGate(Features.OrderImportCustomStore);
